module.exports = __webpack_public_path__ + "static/img/hb1.1d5c205.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hb1.png
// module id = T4oi
// module chunks = 1